import * as React from 'react';
import { pure } from 'recompose';

import UniPng from 'img-src/uni.png';

import Popper from 'ha/ui/next/Popper';
import PartnerPreview from './PartnerPreview';
import { MapProps, UniMarker } from './Types';
import { PartnerMarkerSize } from './constants';

const { width, height, pointX, pointY } = PartnerMarkerSize;

const containerStyle: React.CSSProperties = {
  position: 'absolute',
  width,
  height,
  left: -pointX,
  top: -pointY,
};

const getPinStyle = (scale: number): React.CSSProperties => ({
  position: 'absolute',
  left: 0,
  top: 0,
  transform: `scale(${scale}, ${scale})`,
  transformOrigin: `${pointX}px ${pointY}px`,
  transition: '-webkit-transform 0.25s cubic-bezier(0.485, 1.65, 0.545, 0.835)',
  width,
  height,
  cursor: 'pointer',
  zIndex: scale ? 1999 : 1998,
  backgroundImage: `url(${UniPng})`,
});

interface Props {
  marker: UniMarker;
  lat: number;
  lng: number;
  boundariesElement: HTMLElement | null;
}

export const PartnerMarker: React.SFC<Props & Partial<MapProps>> = ({
  marker,
  $hover,
  boundariesElement,
}) => (
  <div style={containerStyle} title={marker.name}>
    <Popper
      anchor={<div style={getPinStyle($hover ? 1 : 0.5)} />}
      modifiers={{
        preventOverflow: {
          enabled: true,
          boundariesElement: boundariesElement || 'window',
        },
      }}
    >
      {() => <PartnerPreview university={marker} />}
    </Popper>
  </div>
);

PartnerMarker.displayName = 'PartnerMarker';

export default pure(PartnerMarker);
